import { BodyText, FlexColumn } from '@make-software/cspr-design';
import React, { useEffect, useState } from 'react';
import { PluginFormControlsProps } from 'app/components/management/common/plugins/form-control-map';
import { ErrorText, ErrorTextContainer, StyledInput } from 'app/components/common/common-styles';
import styled from 'styled-components';
import { InfoAccordion } from 'app/components/management/common/info-accordion/info-accordion';
import { IntegrationInstructions } from 'app/components/management/common/plugins/action-based/integration-instructions';

export const AccordionRow = styled.div(({ theme }) =>
  theme.withMedia({
    margin: '10px 0 0px 0'
  })
);

export const ActionBasedFormControls = ({
  metadata,
  errors,
  onChange
}: PluginFormControlsProps) => {
  const [payload, setPayload] = useState({ ...metadata });

  useEffect(() => {
    metadata ? setPayload({ ...metadata }) : setPayload({ ...payload, target: 1 });
  }, []);

  useEffect(() => {
    onChange(payload);
  }, [payload]);

  const handleActionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setPayload({ ...payload, action: value });
  };

  const handleTargetChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const number = parseInt(value, 10) || 0;
    setPayload({ ...payload, target: number });
  };

  return (
    <FlexColumn gap={12}>
      <StyledInput
        value={payload?.action}
        label={<BodyText size={1}>Action Name</BodyText>}
        placeholder="user_made_purchance"
        onChange={handleActionChange}
      />
      {errors?.pluginMetadata?.action && (
        <ErrorTextContainer justify={'flex-start'}>
          <ErrorText size={3}>{errors?.pluginMetadata?.action?.message}</ErrorText>
        </ErrorTextContainer>
      )}
      <StyledInput
        value={payload?.target}
        label={<BodyText size={1}>Action Target</BodyText>}
        placeholder="15"
        onChange={handleTargetChange}
      />
      {errors?.pluginMetadata?.target && (
        <ErrorTextContainer justify={'flex-start'}>
          <ErrorText size={3}>{errors?.pluginMetadata?.target?.message}</ErrorText>
        </ErrorTextContainer>
      )}
      <AccordionRow>
        <InfoAccordion disableClickAway={true} renderContent={() => <IntegrationInstructions />}>
          Integration instructions
        </InfoAccordion>
      </AccordionRow>
    </FlexColumn>
  );
};
